import { Button } from 'components';
import { useEffect, useState } from 'react';

const LoginSSO = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location?.search);
    const successParam = urlParams.get('success');
    const token = urlParams.get('access_token');
    const refreshToken = urlParams.get('refresh_token');
    const expiresIn = urlParams.get('expires_in');
    const targetOrigin = window.opener?.location?.origin || process.env.REACT_APP_SSO_REDIRECT;
    const success = successParam === 'true';
    setIsSuccess(success);

    if (isSuccess && token && refreshToken) {
      window.opener?.postMessage(
        {
          type: 'SSO_TOKEN',
          token,
          refreshToken,
          expiresIn,
        },
        targetOrigin, // substitua pelo domínio real da aplicação principal
      );
      // Fecha a aba ou popup após o envio
      window.close();
    }
  }, [isSuccess]);
  const close = () => {
    window.close();
  };
  return (
    <>
      {isSuccess === true ? (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Processando login SSO...</h2>
          <p>Você será redirecionado automaticamente.</p>
        </div>
      ) : (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>
            <b> Acesso inativo</b>
          </h2>
          <h2>
            Seu acesso está inativo no momento. Por favor, entre em contato com o administrador da sua empresa para mais
            informações.
          </h2>
          <Button theme={'primary'} onClick={close}>
            Fechar
          </Button>
        </div>
      )}
    </>
  );
};

export default LoginSSO;
